import { IMPROVE_CONFIG } from "@/config.js";
import axios from "axios";

export default {
  addEvent: function(event) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/events", {
      event_type: event.event_type,
      related_entity: event.related_entity,
      event_data: event.event_data,
      related_entity_asset_id: event.related_entity_asset_id,
      entity_lookup_user_id: event.entity_lookup_user_id,
      entity_type: event.entity_type
    });
  },
  upadteLastWatchedTime: function(asset_id, time) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/update-last-time", {
      asset_id: asset_id,
      time: time
    });
  },
  getLastWatchedTime: function(asset_id) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/get-last-time/" + asset_id);
  },
  updateAssetsIsViewed: function(asset_id) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/assets-viewed", {
      id: asset_id
    });
  },
  updateSuspendedData: function(data){
    return axios.post(IMPROVE_CONFIG.API_URL + "/save-suspend-data", {
      assetId : data.assetId,
      courseUserId: data.courseUserId,
      lastSuspendData: data.lastSuspendData,
      lastLessonLocation: data.lastLessonLocation
    });
  },
  markScormAsCompleted: function(data){
  return axios.post(IMPROVE_CONFIG.API_URL + "/save-scorm-progress", {
      status: data.status,
      asset_id: data.asset_id,
      course_user_id: data.course_user_id
    });
  }
};
